//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfProperty from "~/themes/fiskarsMoominDefault/components/components/atoms/SfProperty/SfProperty.vue";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import { ref, watch } from "@nuxtjs/composition-api";
import { useUiNotification, useSapcc } from "~/composables";
import { CMSNotificationType } from "~/helpers/extractCMSNotificationMessage";

export default {
  name: "CartPricePreview",
  components: {
    SfHeading,
    SfButton,
    SfProperty,
    SfInput,
    SfCharacteristic: () => import("~/themes/fiskarsMoominDefault/components/components/molecules/SfCharacteristic/SfCharacteristic.vue"),
    MoominPaymentMethods: () => import("~/themes/fiskarsMoominDefault/components/components/molecules/MoominPaymentMethods/MoominPaymentMethods.vue"),
  },
  props: {
    hideButtonsWrapper: {
      type: Boolean,
      default: false
    },
    isSidebar: {
      type: Boolean,
    },
    disableCheckoutButton: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: String,
      default: '',
    },
    checkoutUrl: {
      type: String,
    },
    checkoutNextStepButtonText: {
      type: String,
    },
    isCheckout: {
      type: Boolean,
    },
    coupons: {
      type: Array,
      default: () => [],
    },
    cartUrl: {
      type: String,
    },
    cartLoading: {
      type: Boolean,
    },
    productsPrice: {
      type: String,
    },
    wrappingPrice: {
      type: String,
    },
    discountsValue: {
      type: [String, Number],
    },
    totalPrice: {
      type: String,
    },
    shippingPrice: {
      type: String,
    },
    paymentMethods: {
      type: [Array, Object],
      default: () => []
    },
    characteristics: {
      type: Array,
      default: () => []
    },
    alternativeBuy: {
      type: String,
    },
    checkoutText: {
      type: String,
    },
    cartText: {
      type: String,
    },
    goBackText: {
      type: String,
    },
    goBackUrl: {
      type: String,
    },
    paymentMethodsTitle: {
      type: String,
    },
    title: {
      type: String,
    },
    productsPriceLabel: {
      type: String,
    },
    discountsValueLabel: {
      type: String,
    },
    giftWrapLabel: {
      type: String,
    },
    promoCodeInputLabel: {
      type: String,
    },
    appliedPromoCodeHeading: {
      type: String,
    },
    appliedPromoCodeLabel: {
      type: String,
    },
    removePromoCodeLabel: {
      type: String,
    },
    promoCodeLabel: {
      type: String,
    },
    promoCodePlaceholder: {
      type: String,
    },
    promoCodeButtonText: {
      type: String,
    },
    shippingPriceLabel: {
      type: String,
    },
    totalPriceLabel: {
      type: String,
    },
    promoCodeError: String,
    promoCodeRemovedText: String,
    promoCodeAppliedText: String,
  },
  setup(props) {
    const { send: sendNotification } = useUiNotification();
    const { result: cartDetails, getShoppingCart: loadCart } = useSapcc('existingCart');
    const { applyShoppingCartVoucher: addVoucher, removeShoppingCartVoucher: removeVoucher, error } = useSapcc("main");

    const promoCode = ref("");
    const showPromoCodeError = ref(false);
    
    const addPromoCode = async (promoCodeObj) => {
      try {
        const response = await addVoucher(promoCodeObj);
        showPromoCodeError.value = false;
        if (response?.errorMessage) {
          showPromoCodeError.value = true;
        } else {
          promoCode.value = '';
          sendNotification({
            type: CMSNotificationType.SUCCESS,
            message: props.promoCodeAppliedText.replace('${0}', promoCodeObj.voucherId)
          });
        }
        await loadCart();
      } catch (error) {
        sendNotification({
          type: CMSNotificationType.ERROR,
          message: props.promoCodeError
        });
      }
    };

    const removePromoCode = async (promoCodeObj) => {
      try {
        const response = await removeVoucher(promoCodeObj);
        if (response?.errorMessage) {
          sendNotification({
            type: CMSNotificationType.ERROR,
            message: response.errorMessage
          });
        } else {
          sendNotification({
            type: CMSNotificationType.SUCCESS,
            message: props.promoCodeRemovedText.replace('${0}', promoCodeObj.voucherId)
          });
        }
        await loadCart();
      } catch (error) {
        sendNotification({
          type: CMSNotificationType.ERROR,
          message: error
        });
      }
    };

    const handlePromoCodeInput = () => {
      if (!promoCode.value) {
        showPromoCodeError.value = false;
      }
    };

    const hasValueToDisplay = (value) => {
      if(!value) return false;
      if(typeof value === "number") return true;

      // Remove non-numeric characters and convert to a float
      const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));

      // Check if the numeric value is equal to 0
      return numericValue !== 0;
    }

    // Watch for changes to promoCode
    watch(promoCode, (newValue) => {
      if (!newValue) {
        showPromoCodeError.value = false;
      }
    });

    return {
      cartDetails,
      loadCart,
      hasValueToDisplay,
      promoCode,
      showPromoCodeError,
      addVoucher,
      removeVoucher,
      addPromoCode,
      removePromoCode,
      error,
      handlePromoCodeInput
    };
  },
};
